module.exports = "<!-- begin::Scroll Top -->\r\n<div id=\"m_scroll_top\" class=\"m-scroll-top\" appunwraptag=\"\"> <i class=\"la la-arrow-up\"></i> </div>\r\n<!-- end::Scroll Top -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/scroll-top/scroll-top.component.html
// module id = ./src/app/theme/layouts/scroll-top/scroll-top.component.html
// module chunks = main